<template>
  <DatatableReportV3
    v-if="tenantLoaded"
    ref="pending_revenue_datatable"
    title="Pending Revenue"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import { mapGetters, mapState } from "vuex";

import CONSTANTS from "@/Constants.js";
import DepartmentLink from "@/Department/DepartmentLink.vue";
import JobOpportunityLink from "@/Job/Opportunity/JobOpportunityLink.vue";
import AccountingClassLink from "@/Reports/AccountingClassLink.vue";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import store from "@/vuex/store";
import RevenueActionsContextMenu from "./RevenueActionsContextMenu.vue";
import TagList from "@/Tags/TagList.vue";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters(["showAccountingClasses"]),
    ...mapState({
      tenantLoaded({ tenant }) {
        return !!tenant;
      }
    }),
    config() {
      return {
        order: [[0, "desc"]],
        columns: [
          {
            data: "invoice",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.invoices
          },
          {
            data: "customer",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.customers
          },
          { data: "customer_email", title: "Email" },
          { data: "customer_phone", title: "Phone" },
          {
            data: "billing_address",
            title: "Billing Address",
            orderable: false
          },
          { data: "job" },
          { data: "tags", title: "Tags", orderable: false },
          { data: "location_name", title: "Location Name", orderable: false },
          {
            data: "service_address",
            title: "Service Address",
            orderable: false
          },
          {
            data: "last_appointment_time",
            title: "Last Appointment",
            searchable: false
          },
          {
            data: "invoice_last_emailed_at",
            title: "Last Emailed",
            searchable: false
          },
          {
            data: "department",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.departments,
            filterName: "department_id"
          },
          { data: "technician", title: "Owner", filterName: "technician_id" },
          {
            data: "accounting_class",
            title: "Class",
            searchable: false,
            orderable: false,
            visible: this.showAccountingClasses
          },
          {
            data: "revenue",
            className: "text-right",
            footerClassName: "aggregate-currency",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.revenue,
            searchable: false
          },
          {
            data: "balance",
            title: "Balance",
            className: "text-right",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.balance,
            footerClassName: "aggregate-currency",
            footerCellClass: "text-danger",
            filterName: "paid"
          },
          {
            data: "actions",
            title: "",
            searchable: false,
            orderable: false,
            className: "text-center th-no-text"
          }
        ],
        vueComponents: [
          {
            rootId: "department-modal-vue",
            component: DepartmentLink,
            options: {
              store
            }
          },
          {
            rootId: "job-opportunity-modal-vue",
            component: JobOpportunityLink,
            options: {
              store
            }
          },
          {
            rootId: "accounting-class-link-vue",
            component: AccountingClassLink,
            options: {
              store
            }
          },
          {
            rootId: "invoices-context-menu-vue",
            component: RevenueActionsContextMenu,
            options: {
              store
            }
          },
          {
            rootId: "tag-list-vue",
            component: TagList
          }
        ]
      };
    }
  },
  mounted() {
    this.$store.dispatch("addBreadcrumb", { label: "Pending Revenue" });
  }
};
</script>

<style lang="scss" scoped></style>
